module.exports = __webpack_public_path__ + "img/ic_yirenzheng.0f87d784.svg";